import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {getJsonFromUrl} from '../../../../../utils/url';
import {formatQuerystring} from '../../../../../utils/formatting';

import * as productActionCreators from '../../../../../actions/product';
let allActionCreators = Object.assign({}, productActionCreators);

import CheckboxList from '../filterElements/CheckboxList';
import NumericSlider from '../filterElements/NumericSlider';
import GemstoneIcons from '../filterElements/GemstoneIcons';
import StackableIcons from '../filterElements/StackableIcons';
import WomensDiamondIcons from '../filterElements/WomensDiamondIcons';
import StyleIcons from '../filterElements/StyleIcons';
import ValuesSlider from '../filterElements/ValuesSlider';

class MensJewelryFilters extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    let getData = getJsonFromUrl();
    let getKeys = Object.keys(getData);
    let hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;
      
    this.state = {

      budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
      priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
      priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,

      jewelryTypeOpen: true,
      jewelryTypeValues: getKeys.includes('type') ? getData['type'].toLowerCase().split(',') : ['mring', 'mnecklace', 'chains', 'mbracelet'],

      metalsOpen: getKeys.includes('metals'),      
      metalsValues: getKeys.includes('metals') ? getData['metals'].toUpperCase().split(',') : null,

      gemstoneOpen: getKeys.includes('gemstone'),      
      gemstoneValues: getKeys.includes('gemstone') ? getData['gemstone'].toLowerCase().split(',') : null,

      designersOpen: getKeys.includes('designers'),
      designersValues: getKeys.includes('designers') ? getData['designers'].toLowerCase().split(',') : null,

      styleOpen: getKeys.includes('style'),
      styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : [],

      lastReset: Date.now(),
    };

    if(hasQuerystring) {

      let pageNum = getData.currentPage ? parseInt(getData.currentPage) : 1;

      this.props.productSaveProductQueryFilters(getData, 'mens', pageNum);
      setTimeout(() => {
        this.props.updateMethod(formatQuerystring(this.props.product.productFilters));
      }, 150);
    } else {
      this.props.productSaveProductQueryFilters(getData, 'mens', 1);
      setTimeout(() => {
        this.props.updateMethod(formatQuerystring(this.props.product.productFilters));
      }, 150);
    }
  }

  componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.common.registerNavChange && this.props.common.registerNavChange && prevProps.common.registerNavChange != this.props.common.registerNavChange) {
      
      // TODO: refactor into method called on load and change
      let getData = getJsonFromUrl();
      let getKeys = Object.keys(getData);
      let hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;
        
      this.setState({
      
        budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
        priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
        priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,

        jewelryTypeOpen: getKeys.includes('type'),
        jewelryTypeValues: getKeys.includes('type') ? getData['type'].toLowerCase().split(',') : ['mring', 'mnecklace', 'chains', 'mbracelet'],

        metalsOpen: getKeys.includes('metals'),      
        metalsValues: getKeys.includes('metals') ? getData['metals'].toUpperCase().split(',') : null,

        gemstoneOpen: getKeys.includes('gemstone'),      
        gemstoneValues: getKeys.includes('gemstone') ? getData['gemstone'].toLowerCase().split(',') : null,

        designersOpen: getKeys.includes('designer'),
        designersValues: getKeys.includes('designer') ? getData['designer'].toLowerCase().split(',') : null,

        styleOpen: getKeys.includes('style'),
        styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : [],
      });

      if(hasQuerystring) {
        this.props.productSaveProductQueryFilters(getData, 'mens', 1);
        setTimeout(() => {
          this.props.updateMethod(formatQuerystring(this.props.product.productFilters));
        }, 150);
      }
    }
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getDesignerData() {
    return [
      {
        name: 'Diamonds Direct Designs',
        value: 'dddesigns',
      }, 
      {
        name: 'Amden',
        value: 'amden',
      },
      // {
      //   name: 'Christopher Designs',
      //   value: 'christopherdesigns',
      // },
      {
        name: 'Classique Creations',
        value: 'classique',
      },
      // {
      //   name: 'FJ Kashi',
      //   value: 'fjkashi',
      // },
      {
        name: 'Fana',
        value: 'fana',
      },
      // {
      //   name: 'Gabriel & Co',
      //   value: 'gabrielco',
      // },
      {
        name: 'KC Designs',
        value: 'kcdesigns',
      },
      {
        name: 'Mastoloni',
        value: 'mastoloni',
      },
      {
        name: 'Odelia',
        value: 'odelia',
      },
      {
        name: 'Pejay Creations',
        value: 'pejay',
      },
      {
        name: 'Rebeka Hakimi',
        value: 'rebeka',
      },
      {
        name: 'SES',
        value: 'ses',
      },
      {
        name: 'Simon G.',
        value: 'simong',
      },
      {
        name: 'Tacori',
        value: 'tacorif',
      },
      {
        name: 'Uneek',
        value: 'uneek',
      },
    ];
  }

  getMetalTypeData() {
    return [
      {
        name: 'White Gold',
        value: 'WG',
      },
      {
        name: 'Yellow Gold',
        value: 'YG',
      },
      {
        name: 'Rose Gold',
        value: 'RG',
      },
      // {
      //   name: 'Platinum',
      //   value: 'PLAT',
      // },
      // {
      //   name: 'Sterling Silver',
      //   value: 'SS',
      // },
    ]
  }
  
  getGemstoneData() {
    return [
      // {
      //   name: 'Alexandrite',
      //   value: 'alexandrite',
      // },
      // {
      //   name: 'Amethyst',
      //   value: 'amethyst',
      // },
      // {
      //   name: 'Aquamarine',
      //   value: 'aquamarine',
      // },
      // {
      //   name: 'Chalcedony',
      //   value: 'chalcedony',
      // },
      // {
      //   name: 'Citrine',
      //   value: 'citrine',
      // },
      {
        name: 'Diamond',
        value: 'diamond',
      },
      // {
      //   name: 'Emerald',
      //   value: 'emerald',
      // },
      // {
      //   name: 'Garnet',
      //   value: 'garnet',
      // },
      {
        name: 'Lapis',
        value: 'lapis',
      },
      // {
      //   name: 'Morganite',
      //   value: 'morganite',
      // },
      {
        name: 'Onyx',
        value: 'onyx',
      },
      // {
      //   name: 'Opal',
      //   value: 'opal',
      // },
      // {
      //   name: 'Pearl',
      //   value: 'pearl',
      // },
      // {
      //   name: 'Peridot',
      //   value: 'peridot',
      // },
      // {
      //   name: 'Prasiolite',
      //   value: 'prasiolite',
      // },
      // {
      //   name: 'Quartz',
      //   value: 'quartz',
      // },
      // {
      //   name: 'Sapphire',
      //   value: 'sapphire',
      // },
      // {
      //   name: 'Ruby',
      //   value: 'ruby',
      // },
      // {
      //   name: 'Tanzanite',
      //   value: 'tanzanite',
      // },
      // {
      //   name: 'Topaz',
      //   value: 'topaz',
      // },
      // {
      //   name: 'Tourmaline',
      //   value: 'tourmaline',
      // },
      // {
      //   name: 'Turquoise',
      //   value: 'turquoise',
      // },     
    ]
  }

  getJewelryTypeData() {
    return [
      {
        name: 'Rings',
        value: 'mring',
      },
      {
        name: 'Pendants',
        value: 'mnecklace',
      },
      {
        name: 'Chains',
        value: 'chains',
      },
      {
        name: 'Bracelets',
        value: 'mbracelet',
      },
    ]
  }

  toggleFilterElement(element) {

    if(!element) {
      return;
    }

    switch(element) {
      case 'budget':
        this.setState({ budgetOpen: !this.state.budgetOpen });
        return;
      case 'type':
        this.setState({ jewelryTypeOpen: !this.state.jewelryTypeOpen });
        return;
      case 'metals':
        this.setState({ metalsOpen: !this.state.metalsOpen });
        return;
      case 'gemstone':
        this.setState({ gemstoneOpen: !this.state.gemstoneOpen });
        return;
      case 'designer':
        this.setState({ designersOpen: !this.state.designersOpen });
        return;
      case 'style':
        this.setState({ styleOpen: !this.state.styleOpen });
        return;
      default:
        return;
    }
  }

  getElementClass(element) {

    if(!element) {
      return 'filterItem';
    }

    switch(element) {
      case 'budget':
        return this.state.budgetOpen ? 'filterItem open' : 'filterItem';
      case 'type':
        return this.state.jewelryTypeOpen ? 'filterItem open' : 'filterItem';
      case 'metals':
        return this.state.metalsOpen ? 'filterItem open' : 'filterItem';
      case 'gemstone':
        return this.state.gemstoneOpen ? 'filterItem longOpen' : 'filterItem';
      case 'designer':
        return this.state.designersOpen ? 'filterItem longOpen' : 'filterItem';
      case 'style':
        return this.state.styleOpen ? 'filterItem open' : 'filterItem';
      default:
        return 'filterItem';
    }
  }

  filtersUpdated(filterType = null, filterKeys = null, filterValues = null) {

    let newFilters = {};

    console.log(this.props.product.productFilters);
    console.log(this.props.product.productFilters.type);

    if(this.props.product.productFilters && this.props.product.productFilters.type) {
      // Do nothing
    } else {
      newFilters = {
        type: 'mring,mnecklace,chains,mbracelet',
      };
    }

    for(let i=0; i < filterKeys.length; i++) {
      newFilters[filterKeys[i]] = filterValues[i];
    }

    this.props.productSaveProductQueryFilters(newFilters, 'mens');
    setTimeout(() => {
      this.props.updateMethod(formatQuerystring(this.props.product.productFilters));
    }, 200);
  }

  searchAction() {
    this.filtersUpdated('mens', [], []);
    this.props.closeMethod(false);
  }
  
  resetBandFilters() {
    this.setState({
      
      priceMin: 100,
      priceMax: 500000,

      jewelryTypeValues: null,

      metalsValues: null,

      gemstoneValues: null,

      designersValues: null,

      styleValues: [],

      lastReset: Date.now(),

    });

    this.props.productResetProductQueryFilters('mens');
    setTimeout(() => {
      this.props.updateMethod(formatQuerystring(this.props.product.productFilters));
    }, 150);
  }

  render() {
    return <div className='MensJewelryFilters'>
      <div className='rbFilterWrapper'>
        <div className='rbInternalWrapper'>




          <div className={'headerItem filterItem'}>
            <div className='filterHead'>
              <div className='filterLabel'>
                <div className='filterValue'>Men's Jewelry</div>
                <div className='filterReset' onClick={() => this.resetBandFilters()}>
                  Reset
                </div>
              </div>
            </div>
            <div className='filterBody'></div>
          </div>






          <div className={this.getElementClass('type')}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('type')}>
              <div className='filterLabel'>
                <div className='filterValue'>Jewelry Types</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                <CheckboxList 
                  label='Jewelry Types'
                  productType='mens'
                  dataKey='type'
                  refreshData={::this.filtersUpdated}
                  checkboxData={this.getJewelryTypeData()}
                  initData={this.state.jewelryTypeValues}
                  resetElement={null} />
              </div>
            </div>
          </div>



          <div className={this.getElementClass('metals')}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('metals')}>
              <div className='filterLabel'>
                <div className='filterValue'>Metals</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                <CheckboxList 
                  label='Metals'
                  productType='mens'
                  dataKey='metals'
                  refreshData={::this.filtersUpdated}
                  checkboxData={this.getMetalTypeData()}
                  initData={this.state.metalsValues}
                  resetElement={this.state.lastReset} />
              </div>
            </div>
          </div>




          



          <div className={this.getElementClass('gemstone')}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('gemstone')}>
              <div className='filterLabel'>
                <div className='filterValue'>Gemstone</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                <CheckboxList 
                  label='Gemstones'
                  productType='mens'
                  dataKey='gemstone'
                  refreshData={::this.filtersUpdated}
                  checkboxData={this.getGemstoneData()}
                  initData={this.state.gemstoneValues}
                  resetElement={this.state.lastReset} />
              </div>
            </div>
          </div>


          <div className={this.getElementClass('designer')} style={{display: 'none'}}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('designer')}>
              <div className='filterLabel'>
                <div className='filterValue'>Designers</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                <CheckboxList 
                  label='Designers'
                  productType='settings'
                  dataKey='designers'
                  refreshData={::this.filtersUpdated}
                  checkboxData={this.getDesignerData()}
                  initData={this.state.designersValues}
                  resetElement={this.state.lastReset} />
              </div>
            </div>
          </div>


          <div className={this.getElementClass('style')} style={{display: 'none'}}>
            <div className='filterHead' onClick={() => this.toggleFilterElement('style')}>
              <div className='filterLabel'>
                <div className='filterValue'>Style</div>
                <div className='filterReset' style={{display: 'none'}}>
                  <img src='/img/ringbuilder/filter/info.svg' />
                </div>
              </div>
              <div className='filterIcon'>+</div>
              <div className='filterIcon openIcon'>&mdash;</div>
            </div>
            <div className='filterBody'>
              <div className='controlsWrapper'>
                <StyleIcons 
                  searchType={'mens'}
                  refreshData={::this.filtersUpdated} 
                  initData={this.state.styleValues}
                  resetElement={this.state.lastReset} />
              </div>
            </div>
          </div>


          <div className='budgetSection'>
            <div className={'budgetItem ' + this.getElementClass('budget')}>
              <div className='filterHead'>
                <div className='filterLabel'>
                  <div className='filterValue' onClick={() => this.toggleFilterElement('budget')}>Price Range</div>
                </div>
                <div className='filterIcon' onClick={() => this.toggleFilterElement('budget')}>+</div>
                <div className='filterIcon openIcon' onClick={() => this.toggleFilterElement('budget')}>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <NumericSlider
                    minValue={100}
                    maxValue={500000}
                    initMinValue={this.state.priceMin}
                    initMaxValue={this.state.priceMax}
                    minKey={'priceMin'}
                    maxKey={'priceMax'}
                    service={'mens'}
                    format={'currency'}
                    scale={'log'}
                    increment={100}
                    refreshData={::this.filtersUpdated}
                    resetElement={this.state.lastReset} />
                </div>
              </div>
            </div>
          </div>
          




          <div className='submitSection'>
            <button className={'filterSubmitButton dd2ActionButton'} onClick={::this.searchAction}>Search</button>
          </div>
        </div>
      </div>
      <div className='filterSeparation'></div>
    </div>;
  }
}
export default MensJewelryFilters;

function mapStateToProps(state) {
  return {
    common: state.common,
    product: state.product,
  };
}

export const MensJewelryFiltersContainer = connect(
  mapStateToProps,
  allActionCreators
)(MensJewelryFilters);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/filters/MensJewelryFilters.jsx